import React from 'react'
import {CustomerName} from 'app/components/customer/CustomerInfo'

type Props = {
  title?: string
  address: any
  shippingTab?: boolean
}

export const Address: React.FC<Props> = ({title, address, shippingTab}) => {
  if (address && address.id)
    return (
      <div className='mb-3'>
        {title && <div className='fs-5 fw-bolder pb-2'>{title}</div>}
        <>
          <div>
            <span>
              <CustomerName firstName={address.firstName} lastName={address.lastName} />
            </span>
          </div>

          <span>{address.addressLine1}</span>
          <div>
            {address && address.addressLine2
              ? `${address.addressLine2},${address.city}, `
              : `${address.city}, `}
            {address.zipCode}
            {', '}
            <span>
              {address.state?.name}, <span>{address.country?.code}</span>
            </span>
          </div>
        </>
      </div>
    )
  return null
}

export default Address
